import {
  AnimationPlaybackControls,
  MotionValue,
  animate,
  useMotionValue,
  useMotionValueEvent,
  useReducedMotion,
} from 'framer-motion';
import { useEffect, useRef } from 'react';

import resolveMotionEase from './resolveMotionEase';

export default function useSmoothedMotionValue(
  source: MotionValue<number>,
  duration: number,
) {
  const smoothedValue = useMotionValue(source.get());
  const activeAnimation = useRef<AnimationPlaybackControls | null>(null);
  const shouldReduceMotion = useReducedMotion();

  useMotionValueEvent(source, 'change', (latest) => {
    activeAnimation.current?.stop();

    if (shouldReduceMotion || duration === 0) {
      smoothedValue.set(latest);
      return;
    }

    activeAnimation.current = animate(smoothedValue, latest, {
      duration,
      ease: resolveMotionEase('power1.out'),
    });
  });

  useEffect(() => () => activeAnimation.current?.stop(), []);

  return smoothedValue;
}
